module.exports = {
    fi: {
        start: "Aloita",
        next: "Seuraava",
        previous: "Edellinen",
        close: "Sulje",
        skip: "Ohita",
        continue: "Jatka",
        thankYou: "Kiitos",
        or: "tai",
        and: "ja",
        call: "Soita",
        minutes: "minuuttia",
        hour: "tunti",
        hours: "tuntia",
        backFrontpage: "Palaa etusivulle",
        login: "Kirjaudu sisään",
        logout: "Kirjaudu ulos",
        contact: "Ota yhteyttä",
        download: "Lataa",
        delete: "Poista",
        customer: "Asiakas",
        interpreter: "Tulkki",
        news: "Ajankohtaista",
        readMore: "LUE LISÄÄ",
        order: "Tilaa",
        send: "Lähetä",
        loading: "Lataa...",
        dateError: "Tarkasta varauksen ajankohta",
        username: "Sähköpostiosoite tai käyttäjätunnus",
        password: "Salasana",
        booking: "Tee etätulkin ajanvaraus",
        onSite: "Tilaa tulkki paikan päälle",
        indicatesRequired: "vaaditaan",
        sendApplication: "Lähetä hakemus",
        stories: "Tarinat",
        alertMissingDetails: "HUOM. Tilauksen tietoja puuttuu. Tarkista kielet, ajankohta ja muut tiedot palaamalla alkuun",
        here: "tästä",
        alertEmailConfirmFail: "Sähköpostit eivät täsmää",
        alertSubmitFailed: "Tietojen lähetys epäonnistui. Lähetä sähköposti",
    },
    en: {
        start: "Start",
        next: "Next",
        previous: "Previous",
        close: "Close",
        skip: "skip",
        continue: "Continue",
        thankYou: "Thank You",
        or: "or",
        and: "and",
        call: "Call",
        minutes: "minutes",
        hour: "hour",
        hours: "hours",
        backFrontpage: "Back to frontpage",
        login: "Login",
        logout: "Logout",
        contact: "Contact us",
        download: "Download",
        delete: "Delete",
        customer: "Customer",
        interpreter: "Interpreter",
        news: "Insights",
        readMore: "READ MORE",
        order: "Order",
        send: "Send",
        loading: "Loading...",
        dateError: "Check the time of booking",
        username: "Email or username",
        password: "Password",
        booking: "Booking",
        onSite: "I need an interpreter on-site",
        indicatesRequired: "indicates required",
        stories: "Stories",
        alertMissingDetails: "NOTE. Order information is missing. Please check the languages, date, and other details by returning to the beginning",
        here: "here",
        alertEmailConfirmFail: "Email addresses do not match",
        alertSubmitFailed: "Failed to send the form. Please contact us",
    },
    ru: {
        start: "Начать",
        next: "Следующая страница",
        previous: "Предыдущая страница",
        close: "Закрыть",
        skip: "Пропустить",
        continue: "Продолжить",
        thankYou: "Спасибо",
        or: "или",
        and: "и",
        call: "Позвонить",
        minutes: "минут",
        hour: "час",
        hours: "часa",
        backFrontpage: "Перейти на начальную страницу",
        login: "Войти",
        logout: "Выйти",
        contact: "Свяжитесь с нами",
        download: "Lataa",
        delete: "Удалить",
        customer: "Клиент",
        interpreter: "Переводчик",
        news: "Актуальное",
        readMore: "Читать дальше",
        order: "Сделать заказ",
        send: "Отправить",
        loading: "Загружается...",
        dateError: "Проверьте время бронирования.",
        indicatesRequired: "Обязательно указать:",
        booking: "Забронировать удалённый перевод",
        onSite: "Заказать переводчика на место",
        alertMissingDetails: "HUOM. Tilauksen tietoja puuttuu. Tarkista kielet, ajankohta ja muut tiedot palaamalla alkuun",
        here: "здесь",
        alertEmailConfirmFail: "Sähköpostit eivät täsmää", // todo
        alertSubmitFailed: "Failed to send the form. Please contact us", // todo
    },
    sv: {
        start: "Start",
        next: "Nästa",
        previous: "Föregående",
        close: "Stäng av",
        skip: "hoppa över",
        continue: "Fortsätt",
        thankYou: "Tack",
        or: "eller",
        and: "och",
        call: "Ring",
        minutes: "minuter",
        hour: "timme",
        hours: "timmar",
        backFrontpage: "Tillbaka till början",
        login: "Logga in",
        logout: "Logga ut",
        contact: "Ta kontakt",
        download: "Ladda",
        delete: "Radera",
        customer: "Kund",
        interpreter: "Tolk",
        news: "Insikter",
        readMore: "LÄS MER OM",
        order: "Order",
        send: "Skicka",
        loading: "Laddar...",
        dateError: "Check the time of booking",
        username: "e-postadress eller användarnamn",
        password: "Lösenord",
        booking: "Tidsbeställning av tolk",
        onSite: "Behöver tolk på plats",
        alertMissingDetails: "HUOM. Tilauksen tietoja puuttuu. Tarkista kielet, ajankohta ja muut tiedot palaamalla alkuun",
        here: "denna",
        alertEmailConfirmFail: "Sähköpostit eivät täsmää", // todo
        alertSubmitFailed: "Failed to send the form. Please contact us", // todo
    },
    de: {
        start: "Aloita",
        next: "Seuraava",
        previous: "Edellinen",
        close: "Sulje",
        skip: "Ohita",
        continue: "Weiter",
        thankYou: "vielen Dank",
        or: "oder",
        and: "und",
        call: "Rufen Sie uns unter",
        minutes: "minute",
        hour: "stunde",
        hours: "tuntia",
        backFrontpage: "Zurück zur Startseite",
        contact: "Kontaktieren Sie uns",
        download: "Lataa",
        delete: "Poista",
        customer: "Asiakas",
        interpreter: "Tulkki",
        news: "Aktuelles",
        readMore: "LUE LISÄÄ",
        order: "Tilaa",
        send: "Senden",
        loading: "Lataa...",
        dateError: "Tarkasta varauksen ajankohta",
        username: "Sähköpostiosoite tai käyttäjätunnus",
        password: "Salasana",
        booking: "Dolmetscher buchen",
        onSite: "Dolmetscher vor Ort buchen",
        indicatesRequired: "vaaditaan",
        sendApplication: "Lähetä hakemus",
        alertMissingDetails: "HUOM. Tilauksen tietoja puuttuu. Tarkista kielet, ajankohta ja muut tiedot palaamalla alkuun",
        here: "hier",
        alertEmailConfirmFail: "Sähköpostit eivät täsmää", //todo
        alertSubmitFailed: "Failed to send the form. Please contact us", // todo
    },
    is: {
        start : "Byrja",
        next : "Næsta",
        previous : "Fyrri",
        close : "Loka",
        skip : "sleppa",
        continue : "Halda áfram",
        thankYou : "Takk fyrir",
        or : "eða",
        and : "og",
        call : "Hringja",
        minutes : "mínútur",
        hour : "klukkustund",
        hours : "klukkustundir",
        backFrontpage : "Til baka á upphafssíðu",
        login : "Innskráning",
        logout : "Útskráning",
        contact : "Hafðu samband",
        download : "Sækja",
        delete : "Eyða",
        customer : "Viðskiptavinur",
        interpreter : "Túlkur",
        news: "Fréttir",
        order : "Bóka",
        send : "Senda",
        loading : "Hleður ...",
        dateError : "Athugaðu tíma bókunarinnar",
        username : "Netfang eða notandanafn",
        password : "Aðgangsorð",
        booking : "Bókun",
        onSite : "Ég þarf túlk á staðinn",
        indicatesRequired : "gefur til kynna áskilda reiti",
        readMore: "LESA MEIRA",
        alertMissingDetails: "ATH. Pöntunarupplýsingar vantar. Vinsamlegast athugaðu tungumál, dagsetningu og aðrar upplýsingar með því að fara aftur í upphafið",
        here: "héðan",
        alertEmailConfirmFail: "Netföngin passa ekki saman",
        alertSubmitFailed: "Mistókst að senda eyðublaðið. Vinsamlegast hafið samband við okkur",
    },
    ee: {
        start : "TODO",
        next : "TODO",
        previous : "TODO",
        close : "TODO",
        skip : "TODO",
        continue : "TODO",
        thankYou : "TODO",
        or : "TODO",
        and : "TODO",
        call : "TODO",
        minutes : "TODO",
        hour : "TODO",
        hours : "TODO",
        backFrontpage : "TODO",
        login : "TODO",
        logout : "TODO",
        contact : "TODO",
        download : "TODO",
        delete : "TODO",
        customer : "TODO",
        interpreter : "TODO",
        news: "TODO",
        order : "TODO",
        send : "TODO",
        loading : "TODO",
        dateError : "TODO",
        username : "TODO",
        password : "TODO",
        booking : "TODO",
        onSite : "TODO",
        indicatesRequired : "TODO",
        readMore: "TODO",
        alertMissingDetails: "TODO",
        here: "TODO",
        alertEmailConfirmFail: "TODO",
        alertSubmitFailed: "TODO",
    },
};